import { Outlet, NavLink } from 'react-router-dom';
import { FolderOpen, TestTube2 } from 'lucide-react';
import { clsx } from 'clsx';
import { UserMenu } from './UserMenu';

const navigation = [
  { name: 'Case Dashboard', href: '/', icon: FolderOpen },
  { name: 'Model Validation', href: '/validation', icon: TestTube2 },
];

export function Layout() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Compact Header */}
      <header className="sticky top-0 z-40 border-b border-gray-200 bg-white shadow-sm">
        <div className="flex h-12 items-center justify-between px-4 lg:px-6">
          <div className="flex items-center gap-6">
            <NavLink to="/" className="flex items-center gap-2">
              <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary-700">
                <span className="text-xs font-bold text-white">BM</span>
              </div>
              <span className="text-base font-semibold font-display text-navy hidden sm:inline">BetterMatch</span>
              <span className="text-[10px] font-medium text-gray-400 hidden sm:inline">v{__APP_VERSION__}</span>
            </NavLink>

            <nav className="flex gap-0.5">
              {navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  end={item.href === '/'}
                  className={({ isActive }) =>
                    clsx(
                      'flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm transition-all duration-150',
                      isActive
                        ? 'bg-primary-100 text-primary-800 font-semibold ring-1 ring-primary-200'
                        : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900 font-medium'
                    )
                  }
                >
                  <item.icon className={clsx('h-4 w-4')} aria-hidden="true" />
                  <span className="hidden sm:inline">{item.name}</span>
                </NavLink>
              ))}
            </nav>
          </div>

          <UserMenu />
        </div>
      </header>

      {/* Main Content - Full width with responsive padding */}
      <main className="px-4 py-4 lg:px-6 lg:py-5">
        <Outlet />
      </main>
    </div>
  );
}
